import { render, staticRenderFns } from "./HistoryWeb.vue?vue&type=template&id=3b002f7f&"
import script from "./HistoryWeb.vue?vue&type=script&lang=js&"
export * from "./HistoryWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports